<template>
  <div>
    <el-aside
      :style="{
        width: isCollapse ? '65px' : '160px',
        transition: 'width  0.2s ease-in',
      }"
    >
      <div
        class="sidebar-inner"
        :style="{
          width: isCollapse ? '65px' : '160px',
          transition: 'width  0.2s ease-in',
        }"
      >
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          :collapse="true"
        >
          <template v-for="item in (roleId!=configRoleId? menuChildsData : networkMenu)" :key="item.orders">
            <!-- 存在多级 -->
            <template v-if="item.childs.length > 0">
              <el-sub-menu :index="item.orders + ''">
                <template #title>
                  <el-icon>
                    <component v-if="item.icon" :is="item.icon" />
                  </el-icon>
                  <el-row
                    class="onelevel_menu"
                    :index="item.orders.toString()"
                    v-if="!isCollapse"
                    >{{ item.name }}</el-row
                  >
                </template>
                <!-- 展开二级 -->
                <template v-for="item2 in item.childs" :key="item2.orders">
                  <el-menu-item
                    class="childs_heigth"
                    :index="
                      item.orders.toString() + '-' + item2.orders.toString()
                    "
                    @click="
                      addTabC({
                        name: item.orders.toString() + item2.orders.toString(),
                        title: item2.name,
                        component: item2.component,
                      })
                    "
                  >
                    <el-icon>
                      <component :is="item2.icon" />
                    </el-icon>
                    <el-row
                      class="onelevel_menu"
                      :index="item2.orders.toString()"
                      >{{ item2.name }}</el-row
                    >
                  </el-menu-item>
                </template>
              </el-sub-menu>
            </template>
            <!-- 只存在一级 -->
            <template v-else>
              <el-menu-item
                class="menu_no_child"
                :index="item.orders.toString()"
                @click="
                  addTabC({
                    name: item.orders.toString(),
                    title: item.name,
                    component: item.component,
                  })
                "
              >
                <el-icon>
                  <component :is="item.icon" />
                </el-icon>
                <el-row
                  class="onelevel_menu"
                  :index="item.orders.toString()"
                  v-if="!isCollapse"
                  >{{ item.name }}</el-row
                >
              </el-menu-item>
            </template>
          </template>
        </el-menu>
        <!-- 菜单右侧展开收缩按钮 -->
        <div
          class="sidebar-collapse-btn"
          :class="{ isLeftClick: isLeftClick }"
          :style="{
            transition: 'left  0.2s ease-in',
          }"
          @click="openClick"
        >
          <el-icon v-show="!isCollapse">
            <ArrowLeft></ArrowLeft>
          </el-icon>
          <el-icon v-show="isCollapse">
            <ArrowRight></ArrowRight>
          </el-icon>
        </div>
      </div>
    </el-aside>
  </div>
</template>

<script>
import { useStore } from "vuex";
import {
  reactive,
  ref,
  computed,
  toRefs,
  defineComponent,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  provide,
} from "vue";
import { isNull } from "../../common/utils";

export default defineComponent({
  emits: ["changeCollapse", "defaultPage", "addTab"],
  setup(props, { emit }) {
    const store = useStore();
    const userAdmin = computed(() => store.state.AdminCache);
    const roleId = computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId);
    const configRoleId = computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId);
    const data = reactive({
      // 当前显示的tabpane组件
      menuChildsData: [
        {
          component: "",
          icon: "OfficeBuilding",
          name: "院校设置",
          orders: 1,
          childs: [
            {
              component: "SchoolManagement",
              icon: "ArrowRight",
              name: "学历院校管理",
              orders: 1,
              childs: [
                {
                  component: "SchoolManagement",
                  icon: "ArrowRight",
                  name: "三级试一下",
                  orders: 1,
                  childs: [],
                },
              ],
            },
            {
              component: "MajorCategory",
              icon: "ArrowRight",
              name: "专业类别设置",
              orders: 2,
              childs: [],
            },
            // {
            //   component: "PbSchoolManagement",
            //   icon: "ArrowRight",
            //   name: "普本院校管理",
            //   orders: 3,
            //   childs: [],
            // },
            // {
            //   component: "PbMajor",
            //   icon: "ArrowRight",
            //   name: "普本专业",
            //   orders: 4,
            //   childs: [],
            // },
            // {
            //   component: "PbMajorSchool",
            //   icon: "ArrowRight",
            //   name: "普本专业院校",
            //   orders: 5,
            //   childs: [],
            // },
            {
              component: "NotPbMajor",
              icon: "ArrowRight",
              name: "学历类专业",
              orders: 3,
              childs: [],
            },
            {
              component: "ExaminationGuide",
              icon: "ArrowRight",
              name: "报考指南",
              orders: 4,
              childs: [],
            },
          ],
        },
        {
          component: "",
          icon: "Reading",
          name: "文章资讯",
          orders: 2,
          childs: [
            {
              component: "ArticleClassification",
              icon: "ArrowRight",
              name: "文章分类",
              orders: 1,
              childs: [],
            },
            {
              component: "ArticleList",
              icon: "ArrowRight",
              name: "文章管理",
              orders: 2,
              childs: [],
            },
            {
              component: "ArticleComments",
              icon: "ArrowRight",
              name: "文章评论",
              orders: 3,
              childs: [],
            },
            {
              component: "AddEditarticleList",
              icon: "ArrowRight",
              name: "添加文章",
              orders: 4,
              childs: [],
            }
           
          ],
        },
        {
          component: "ProjectManagement",
          icon: "Notification",
          name: "专题管理",
          orders: 3,
          childs: [],
        },
        {
          component: "",
          icon: "Position",
          name: "推广设置",
          orders: 4,
          childs: [
            {
              component: "SlideManagement",
              icon: "ArrowRight",
              name: "幻灯片管理",
              orders: 1,
              childs: [],
            },
             {
              component: "AdvertisingImages",
              icon: "ArrowRight",
              name: "广告图植入",
              orders: 2,
              childs: [],
            },
             {
              component: "ButtonClickStatistics",
              icon: "ArrowRight",
              name: "按钮点击统计",
              orders: 3,
              childs: [],
            },
          ],
        },
        {
          component: "",
          icon: "Message",
          name: "学员信息",
          orders: 5,
          childs: [
            {
              component: "RegistrationInfo",
              icon: "ArrowRight",
              name: "报名信息管理",
              orders: 1,
              childs: [],
            },
          ],
        },
        {
          component: "",
          icon: "Setting",
          name: "系统配置",
          orders: 6,
          childs: [
            // {
            //   component: "TemplateFileManagement",
            //   icon: "ArrowRight",
            //   name: "模板文件管理",
            //   orders: 1,
            //   childs: [],
            // },
             {
              component: "ParticipleManagement",
              icon: "ArrowRight",
              name: "分词管理",
              orders: 1,
              childs: [],
            },
            {
              component: "ConfigServer",
              icon: "ArrowRight",
              name: "配置中心",
              orders: 2,
              childs: [],
            },
            {
              component: "FocusFigure",
              icon: "ArrowRight",
              name: "小程序背景图",
              orders: 3,
              childs: [],
            },
             {
              component: "PageUpdate",
              icon: "ArrowRight",
              name: "前台页面更新",
              orders: 4,
              childs: [],
            },
             {
              component: "UpdateIndex",
              icon: "ArrowRight",
              name: "更新索引",
              orders: 5,
              childs: [],
            },
            {
              component: "DutyTeacher",
              icon: "ArrowRight",
              name: "值班老师列表",
              orders: 6,
              childs: [],
            },
            {
              component: "TeacherScheduling",
              icon: "ArrowRight",
              name: "老师排班",
              orders: 7,
              childs: [],
            },
            {
              name: "系统接口文档",
              componentName: "",
              orders: 8,
              icon: "ArrowRight",
              childs: [],
            },
            {
              name: "日志管理",
              component: "SystemLog",
              orders: 9,
              icon: "ArrowRight",
              childs: [],
            }
          ],
        },
      ], //登录的管理员菜单数据

      // 网编菜单
      networkMenu:[
        {
          component: "",
          icon: "OfficeBuilding",
          name: "院校设置",
          orders: 1,
          childs: [
            {
              component: "SchoolManagement",
              icon: "ArrowRight",
              name: "学历院校管理",
              orders: 1,
              childs: [
                {
                  component: "SchoolManagement",
                  icon: "ArrowRight",
                  name: "三级试一下",
                  orders: 1,
                  childs: [],
                },
              ],
            },
            {
              component: "MajorCategory",
              icon: "ArrowRight",
              name: "专业类别设置",
              orders: 2,
              childs: [],
            },
            {
              component: "NotPbMajor",
              icon: "ArrowRight",
              name: "学历类专业",
              orders: 3,
              childs: [],
            },
            {
              component: "ExaminationGuide",
              icon: "ArrowRight",
              name: "报考指南",
              orders: 4,
              childs: [],
            },
          ],
        },
        {
          component: "",
          icon: "Reading",
          name: "文章资讯",
          orders: 2,
          childs: [
            {
              component: "ArticleClassification",
              icon: "ArrowRight",
              name: "文章分类",
              orders: 1,
              childs: [],
            },
            {
              component: "ArticleList",
              icon: "ArrowRight",
              name: "文章管理",
              orders: 2,
              childs: [],
            },
            {
              component: "ArticleComments",
              icon: "ArrowRight",
              name: "文章评论",
              orders: 3,
              childs: [],
            },
          ],
        },
        {
          component: "ProjectManagement",
          icon: "Notification",
          name: "专题管理",
          orders: 3,
          childs: [],
        },
      ],
      defaultTheMenu: {
        name: "11", //当前处于二级  给一级orders+二级orders
        title: "学历院校管理",
        component: "SchoolManagement",
      },
      //控制菜单栏展开收缩 *切勿修改
      isCollapse: false,
      isLeftClick: false,
    });
    // 右侧展开收缩按钮
    const openClick = () => {
      data.isLeftClick = !data.isLeftClick;
      data.isCollapse = !data.isCollapse;
      // 将当前控制展开与收缩的字段抛出
      emit("changeCollapse", data.isCollapse);
    };
    // 新开窗口tab
    const addTabC = (tabObj) => {
      // console.log(tabObj);
      if(tabObj.title=='系统接口文档'){
        window.open(store.state.AdminCache.siteApiUrl, "_blank");
        return
      }
      emit("addTab", tabObj);
    };
    const getDefaultPage = async () => {
      emit("defaultPage", data.defaultTheMenu);
      // console.log(res);
    };
    onMounted(() => {
      //执行请求
      getDefaultPage();
    });
    return {
      userAdmin,
      roleId,
      configRoleId,
      ...toRefs(data),
      openClick,
      addTabC,
    };
  },
});
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 160px;
}
.el-sub-menu.is-opened >>> .el-sub-menu__title .el-icon-arrow-right {
  transform: rotateZ(-90deg);
}
.one + .el-sub-menu__icon-arrow.el-icon-arrow-down {
  transform: rotateZ(-90deg) !important;
}
.el-sub-menu .el-menu-item::before {
  width: 0;
}
/* 左侧菜单 */
.el-aside {
  height: 100%;
}
.sidebar-inner {
  height: 100%;
  background-color: #1f2935;
  position: relative;
}
.sidebar-inner .el-sub-menu .el-menu-item {
  padding: 0 45px;
  min-width: 150px;
  height: 50px;
}
.sidebar-inner .el-menu {
  border-right: solid 1px #1f2935;
}
.sidebar-inner .el-menu--collapse {
  width: 100% !important;
  background-color: #344154;
  // color: #fff;
}
//选中字体颜色 未选中字体、icon
::v-deep .el-menu-vertical-demo .is-active .el-sub-menu__title,
.el-menu-vertical-demo ::v-deep .el-sub-menu__title .onelevel_menu,
.el-sub-menu .el-icon {
  color: var(--textColor, #fff);
}
// 次级菜单字体颜色
.el-menu-item.is-active {
  color: #000;
}

// 菜单名称
.onelevel_menu {
  display: inline-block;
  margin-left: 19px;
}
.el-menu--collapse .el-sub-menu {
  border-bottom: 1px solid #4f5154;
}
// 一级菜单移入改变底色
::v-deep .el-sub-menu__title:hover,
::v-deep .el-sub-menu.is-active .el-sub-menu__title {
  background-color: #131d29 !important;
}
// 鼠标经过竖条样式
::v-deep .el-sub-menu__title:hover::before,
::v-deep .menu_no_child.el-menu-item:hover::before {
  content: "";
  width: 6px;
  height: 50px;
  display: inline-block;
  background-color: #409eff !important;
  // background-color: #409eff;
  position: absolute;
  left: 0;
  z-index: 2;
  border-radius: 0px 3px 3px 0px;
}
// 二级菜单高度设置
.el-sub-menu,
.menu_no_child,
::v-deep .el-sub-menu__title,
.childs_heigth.el-menu-item {
  height: 50px;
}
.menu_no_child {
  border-bottom: 1px solid #4f5154;
}
.el-menu--popup-container .el-menu-item {
  border-bottom: 1px solid #eee !important;
}
// 选中竖条色
::v-deep .sidebar-inner .is-active::before {
  content: "";
  width: 6px;
  height: 50px;
  display: inline-block;
  background-color: #409eff !important;
  // background-color: #409eff;
  position: absolute;
  left: 0;
  z-index: 2;
  border-radius: 0px 3px 3px 0px;
}
//  选中左边竖条颜色
.el-menu--vertical .el-menu--popup .is-active::before {
  content: "";
  width: 6px;
  height: 50px;
  background-color: #409eff !important; //竖条颜色
  position: absolute;
  left: 0;
  border-radius: 0px 3px 3px 0px;
  z-index: 9999;
}

/* 左侧菜单收起展开图标 */
.sidebar-collapse-btn {
  position: fixed;
  top: 50%;
  left: 160px;
  width: 15px;
  height: 53px;
  line-height: 53px;
  text-align: center;
  margin-top: -24px;
  border: 1px soid #409eff;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  transition: left 0.05s ease-in;
  z-index: 99;
}
// 侧边栏隐藏按钮背景色
.sidebar-collapse-btn {
  background-color: #344154;
  color: var(--textColor, #fff);
}
.sidebar-inner .isLeftClick {
  left: 65px;
  transition: left 0.05 ease-in;
}
// 仅存在一个菜单的情况
.menu_no_child,
::v-deep .menu_no_child .el-icon {
  color: #fff;
}
.menu_no_child.is-active {
  color: #fff;
  border-bottom: 1px solid #4f5154;
  background-color: #131d29 !important;
}
.menu_no_child.el-menu-item:hover {
  background-color: #131d29 !important;
}

// ::v-deep body .el-poppe{
//   left: 180px !important;
// }
</style>
<style>
/* 以下样式必须放在全局css内，否则不生效 */
.el-menu--popup {
  padding: 0 !important;
}
.el-menu--vertical .el-menu-item.is-active {
  background-color: var(--el-menu-hover-bg-color);
}
</style>
